import { useTopImpactStories } from '#src/app/pages/homepage/shared/hooks';
import type { TopStoryDesktop } from '#src/app/pages/homepage/shared/types';

type Result = ModelHookResult<
	{
		desktopStories: TopStoryDesktop[];
	},
	{
		trackStoryClick: (url: string) => void;
	}
>;

const getPositionClasses = (index: number) => {
	switch (index) {
		case 1:
			return {
				isDesktopCentered: false,
			};
		case 2:
			return {
				isDesktopCentered: true,
			};
		case 3:
			return {
				isDesktopCentered: false,
			};
		default:
			return {
				isDesktopCentered: false,
			};
	}
};

export function useTopImpactStoriesDesktop(): Result {
	const {
		data: { topStories },
		actions: { trackStoryClick },
	} = useTopImpactStories();

	return {
		data: {
			desktopStories: topStories.map((story, index) => ({
				...story,
				...getPositionClasses(index),
			})),
		},
		actions: {
			trackStoryClick,
		},
	};
}
